import { render } from "./DownloadComp.vue?vue&type=template&id=57e82810&scoped=true&ts=true"
import script from "./DownloadComp.vue?vue&type=script&lang=ts"
export * from "./DownloadComp.vue?vue&type=script&lang=ts"

import "./DownloadComp.vue?vue&type=style&index=0&id=57e82810&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e82810"]])

export default __exports__